import apiService from "./apiService"

const dashboardApiSlice = apiService.injectEndpoints({
  endpoints: (builder) => ({
    fetchReviews: builder.mutation({
      query: (params) => {
        return {
          url: `review`,
          method: "GET",
          params: params,
        }
      },
      transformResponse: (response, meta, arg) => response.data,
    }),
    syncReview: builder.mutation({
      query: (params) => {
        return {
          url: "review",
          method: "POST",
          params: params,
        }
      },
      transformResponse: (response, meta, arg) => response.data,
    }),

    fetchLocations: builder.query({
      query: () => ({ url: "location" }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    fetchSourceList: builder.query({
      query: () => ({ url: "source" }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    fetchUserListByLocation: builder.mutation({
      query: (locations) => ({
        url: "user/getbylocation",
        method: "POST",
        body: { locations: locations },
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
  }),
})

export default dashboardApiSlice

export const {
  useFetchReviewsMutation,
  useLazyFetchLocationsQuery,
  useLazyFetchSourceListQuery,
  useFetchUserListByLocationMutation,
  useSyncReviewMutation,
} = dashboardApiSlice
